module.exports = __webpack_public_path__ + "static/prodinity_main_4-d58537b0041a62366e3c222a1a8d838e.png";